import {newsApi} from './api';

export const TractorsService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getTractors: build.query({
            query: ({id, pagination}) => ({
                url: `tractors-trailers/get/${id}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addTractor: build.mutation({
            query: (form) => ({
                url: `tractors-trailers/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editTractor: build.mutation({
            query: ({id, newForm}) => ({
                url: `tractors-trailers/update/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeTractor: build.mutation({
            query: (id) => ({
                url: `tractors-trailers/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetTractorsQuery,
    useAddTractorMutation,
    useEditTractorMutation,
    useRemoveTractorMutation,
} = TractorsService